import { BadgeCheck } from "lucide-react";

export const VerifiedBadge = ({ size = 16, testId = "verified-badge" }) => (
  <BadgeCheck size={size} fill="#1D9BF0" color="#FFFFFF" strokeWidth={2.4}
    className="inline-block shrink-0 -mt-0.5 ml-1 align-middle" aria-label="Verificado" data-testid={testId} />
);
